import React, {useEffect, useRef, useState} from "react";
import {useSelector} from "react-redux";
import {
    IconHeart
} from "@searchComponents/icons";
import clsx from "clsx";
import Popover from "./Popover";

function FavourSnippet() {
    const { wishlistUrl, wishlistText } = useSelector(({ rootReducer }) => rootReducer.baseSettings);
    const [show, setShow] = useState(false);
    const popoverRef = useRef();
    const wishList = useSelector(({ wishListReducer }) => wishListReducer.wishList);
    const [wishListLength, setWishListLength] = useState(0);

    /**
     * Get the wishlist length
     */
    useEffect(() => {
        // eslint-disable-next-line
        let wishListTrue = Number(Object.values(wishList).filter(e => e).length);
        setWishListLength(wishListTrue);
    }, [wishList]);

    return (
        <div onClick={() => setShow(!show)}
             className={clsx(
                 'favour-snippet-container',
                 (show || wishListLength > 0) && 'favour-snippet--active'
             )}
        >
            <div className='favour-snippet__count'>
                <IconHeart/>
                {wishListLength
                    ? <span className='favour-snippet__count-length'>{wishListLength}</span>
                    : <span className='favour-snippet__count-length'/>
                }
            </div>
            <Popover
                title={"Your favour items:"}
                show={show}
                popoverRef={popoverRef}
            >
                <ul className='favour-snippet__list'>
                    {Object.keys(wishList).map((item, key) => {
                        if (wishList[item].title && wishList[item].status !== false) {
                            return (
                                <li className="favour-snippet__list-item" key={key}>
                                    <a href={wishList[item].link}>
                                        <span dangerouslySetInnerHTML={{ __html: decodeURI(wishList[item].title) }} />
                                    </a>
                                </li>
                            );
                        }
                    })}
                </ul>
                {wishListLength === 0 && (
                    <span style={{textAlign: "center"}}>No saved jobs.</span>
                )}
                {wishlistUrl && wishlistText && (
                    <div className="favour-snippet__list-btn-container">
                        <a className="favour-snippet__list-btn" href={wishlistUrl}>{wishlistText}</a>
                    </div>
                )}
            </Popover>
        </div>
    );
}

export default FavourSnippet;
